<template>
    <div class="border rounded-5 bg-white border-tc-orange-1 p-4">
        <div class="text-center text-tc-orange-1 text-20 pb-3"> กรมธรรม์ของคุณกำลังจะหมดอายุ </div>
        <div class="text-center w-44 mx-auto">
            <RedBtn>
                <img class="w-4 inline-block" src="@/assets/icon/insurance-icon.png" >
                ดูข้อมูลกรมธรรม์
            </RedBtn>
        </div>
    </div>
</template>

<script>
import RedBtn from '@/components/Button/RedBtn.vue'
export default {
    name: 'Insuranceexpire',
    components:{
        RedBtn
    },
    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>

<style lang="scss" scoped>
</style>
